import { useState } from "react";
import type { Lesson } from "../types";

export function useLessons(initial: Lesson[] = [{ id: 1, title: "", description: "", videoProvider: "Cloudflare"}]) {
  const [lessons, setLessons] = useState<Lesson[]>(initial);

  const patchLesson = (idx: number, patch: Partial<Lesson>) => {
    setLessons((prev) => prev.map((l, i) => (i === idx ? { ...l, ...patch } : l)));
  };

  const moveDown = (idx: number) => {
    setLessons((prev) => {
      if (idx >= prev.length - 1) return prev;
      const arr = [...prev];
      [arr[idx + 1], arr[idx]] = [arr[idx], arr[idx + 1]];
      return arr;
    });
  };

  const moveUp = (idx: number) => {
    if (idx <= 0) return;
    setLessons((prev) => {
      const arr = [...prev];
      [arr[idx - 1], arr[idx]] = [arr[idx], arr[idx - 1]];
      return arr;
    });
  };

  const duplicate = (idx: number) => {
    setLessons((prev) => {
      const arr = [...prev];
      const clone = { ...arr[idx], id: Date.now() + Math.random() };
      arr.splice(idx + 1, 0, clone);
      return arr;
    });
  };

  const removeLesson = (idx: number) =>
    setLessons((prev) => prev.filter((_, i) => i !== idx));

  const addLesson = () =>
    setLessons((prev) => [...prev, { id: Date.now(), title: "", description: "", videoProvider: "Cloudflare" }]);

  return {
    lessons,
    setLessons,
    patchLesson,
    moveDown,
    moveUp,
    duplicate,
    removeLesson,
    addLesson,
  };
}
